import React from 'react';
import TableRow from './TableRow';

const TableBody = ({ operations }) => {
    const rows = operations.map(operation => <TableRow key={operation.id} {...operation} />);
    return <tbody>{rows}</tbody>;
};

export default TableBody;


// WEBPACK FOOTER //
// ./src/ZWallet/Operations/components/TableBody.js